<!-- eslint-disable max-lines -->
<template>
    <div class="dialogTable">
        <slot name="myHeader"></slot>
        <el-table
            border
            ref="dialogTable"
            :height="dialogTable.height"
            style="width:100%;"
            @cell-dblclick="celldblclick"
            :data="dialogTable.isPagination?paginationTableData[currentPage-1]:tableData"
            @selection-change="selectionChange"
        >
            <el-table-column type="selection" width="36" v-if="dialogTable.selection" fixed="left"></el-table-column>
            <el-table-column
                v-for="(column,index) in dialogTable.columns"
                :key="index"
                :label="column.label"
                :property="column.prop"
                :fixed="column.fixed"
                :min-width="column.width"
                :show-overflow-tooltip="!column.noShowTooltip"
            >
                <template slot-scope="scope">
                    <div v-if="scope.row.editRow">
                        <el-select
                            v-if="column.type==='select'"
                            v-model="scope.row[column.prop]"
                            @change="change(scope,column.prop)"
                            :clearable="!column.unclearable"
                            :disabled="column.disabled || scope.row[`${column.prop}Disabled`]"
                            :class="{showMustFill:scope.row.showMustFill&&column.mustFill&&canShow(scope.row,column)}"
                        >
                            <el-option
                                v-for="(item,index) in column.options"
                                :key="index"
                                :label="item.label"
                                :value="item.value"
                                :disabled="(item.disabled) || scope.row[`${column.prop}${item.value}OptionDisabled`]"
                            ></el-option>
                        </el-select>
                        <otpAdvance v-else-if="column.type==='advance'" :params="column" :mValue="scope.row[column.prop]"
                            @getAdvanceValue="getAdvanceValue($event,scope,column.prop)" :formData="scope.row"
                            :disabled="column.disabled || scope.row[`${column.prop}Disabled`]"></otpAdvance>
                        <span v-else-if="column.type==='text'">{{scope.row[column.prop]}}</span>
                        <!-- 针对时效站点读取不同配置加的（时间紧改动小） -->
                        <template v-else-if="column.type==='agingSitAdvance'">
                            <otpAdvance :params="scope.$index === 0 ? column.params[0] : column.params[1]" :mValue="scope.row[column.prop]"
                                @getAdvanceValue="getAdvanceValue($event,scope,column.prop)" :formData="scope.row"
                                :disabled="column.disabled || scope.row[`${column.prop}Disabled`]"></otpAdvance>
                        </template>
                        <el-input
                            v-model="scope.row[column.prop]"
                            @change="change(scope,column.prop)"
                            :disabled="column.disabled"
                            :class="{showMustFill:scope.row.showMustFill&&column.mustFill&&canShow(scope.row,column)}"
                            v-else
                        ></el-input>
                    </div>
                    <template v-else>
                        {{dataShow(scope.row[column.prop],column,scope)}}
                    </template>
                </template>
            </el-table-column>
            <el-table-column
                label="操作"
                :fixed="dialogTable.action.fixed"
                v-if="dialogTable.action && dialogTable.btnActive"
                :width="dialogTable.action.width"
            >
                <template slot-scope="scope">
                    <div>
                        <el-button
                            type="text"
                            v-for="(item,index) in dialogTable.action.list"
                            :key="index"
                            @click="handleTableData(item.event,scope.row,scope.$index+(pageSize*(currentPage-1)))"
                        >{{item.text}}</el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <slot name="myFooter"></slot>
        <div class="block dialogTablePagination" v-if="dialogTable.isPagination">
            <el-pagination
                class="table-pagination"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next"
                :total="tableData.length"
            ></el-pagination>
        </div>
    </div>
</template>

<script>
/* eslint-disable camelcase */
/* eslint-disable max-depth */
/* eslint-disable operator-linebreak */
/* eslint-disable max-statements */
/* eslint-disable no-magic-numbers */

import otpAdvance from '@/components/lots/otpAdvance';
import { dictWithUrl } from '@/components/otpPanel/api';
export default {
    data() {
        return {
            pageSize: 10,
            currentPage: 1,
            paginationTableData: [],
            mTableData: []
        };
    },
    props: {
        tableData: Array,
        dialogTable: Object,
        dbclick: {
            type: Boolean,
            default: false
        }
    },
    components: { otpAdvance },
    created() {
        this.getDictionary();
        this.dataInit();
        this.mTableData = this.tableData;
    },
    watch: {
        mTableData() {
            this.mTableData = this.tableData;
        },
        tableData() {
            this.dataInit();
        },
        pageSize() {
            this.dataInit();
        }
    },
    methods: {
        canShow(row, column) {
            return !(row[column.prop] || row[column.prop].length || row[column.prop] === 0);
        },
        getDictionary() {
            this.dialogTable.columns.map((item, index) => {
                item.options = [];
                if (item.type === 'select' && item.optionNum) {
                    const arr = [];
                    dictWithUrl(item.optionNum).then(res => {
                        if (res && res.code === '0') {
                            for (const key in res.data[item.optionNum]) {
                                if (
                                    res.data[item.optionNum].hasOwnProperty(key)
                                ) {
                                    arr.push({
                                        value: key,
                                        label: res.data[item.optionNum][key]
                                    });
                                }
                            }
                        }
                        item.options = arr;
                    });
                }
            });
        },
        handleSizeChange(val) {
            this.pageSize = val;
        },
        handleCurrentChange(val) {
            this.currentPage = val;
        },
        selectionChange(selection) {
            if (this.dialogTable.selection) {
                this.mTableData = selection;
                this.$emit('selectionChange', selection);
            }
        },
        celldblclick(row, column, cell, event) {
            if (row[column.property] === undefined) return;
            if (this.dbclick) {
                var clickTabContent = row[column.property];
                const inputEle = document.createElement('input');
                document.body.appendChild(inputEle);
                inputEle.setAttribute('value', clickTabContent);
                inputEle.setAttribute('readonly', 'readonly');
                inputEle.select();
                document.execCommand('copy');
                document.body.removeChild(inputEle);
                this.$message.success(`‘${inputEle.value}’ 复制成功`);
            }
        },
        change(data, key) {
            if (!this.mTableData[data.$index]) {
                this.mTableData[data.$index] = {};
            }
            if (this.dialogTable.isPagination) {
                this.mTableData[this.pageSize * (this.currentPage - 1) + data.$index][key] = data.row[key];
            } else {
                this.mTableData[data.$index][key] = data.row[key];
            }
            this.$emit('change', { data, key });
        },
        getAdvanceValue(valObj, data, key) {
            Object.keys(valObj).forEach(k => {
                if (this.dialogTable.isPagination) {
                    this.tableData[this.pageSize * (this.currentPage - 1) + data.$index][k] = valObj[k];
                } else {
                    this.tableData[data.$index][k] = valObj[k];
                }
            });
            this.$emit('change', { data, key });
        },
        getDialogTableData() {
            return this.tableData;
        },
        tableShowMustFill() {
            let flag = false;
            this.dialogTable.columns.map(child => {
                if (child.mustFill) {
                    this.tableData.map((item, index) => {
                        if (!(item[child.prop] || item[child.prop.length])) {
                            this.tableData[index].showMustFill = true;
                            this.dataInit();
                            flag = true;
                        } else {
                            this.tableData[index].showMustFill = false;
                            this.dataInit();
                        }
                    });
                }
            });
            return flag;
        },
        dataInit() {
            if (this.dialogTable.isPagination) {
                const tableData = [];
                let arr = [];
                this.tableData.map((item, index) => {
                    arr.push(item);
                    if (
                        (index + 1) % this.pageSize === 0 ||
                        index === this.tableData.length - 1
                    ) {
                        tableData.push(arr);
                        arr = [];
                    }
                });
                this.paginationTableData = tableData;
            }
        },
        addRow() {
            let flag = false;
            // this.tableData.map(item => {
            //     delete item.editRow;
            // });
            for (const key in this.tableData[this.tableData.length - 1]) {
                if (this.tableData[this.tableData.length - 1].hasOwnProperty(key)) {
                    if (this.tableData[this.tableData.length - 1][key] && this.tableData[this.tableData.length - 1][key] !== 0) {
                        flag = true;
                    }
                }
            }
            if (!flag && this.tableData.length !== 0) {
                this.$message.error('新增行数据不能为空');
                this.tableData[this.tableData.length - 1].editRow = true;
                return;
            }
            const obj = {};
            this.dialogTable.columns.map((item, index) => {
                obj[item.prop] = '';
            });
            obj.editRow = true;
            this.tableData.push(obj);
            this.currentPage = Math.ceil(this.tableData.length / this.pageSize);
        },
        dataShow(value, column, row) {
            let str = '';
            if (column.type === 'select' && column.options.length) {
                column.options.map(item => {
                    if (item.value === value + '') {
                        str = item.label;
                    }
                });
            } else {
                str = value;
            }
            return str;
        },
        handleTableData(event, row, index) {
            // 按钮事件
            if (event === 'delete') {
                this.$emit('dialogDelRow', row, index, this.tableData);
                if (this.dialogTable.isPagination) {
                    this.currentPage = Math.ceil(
                        this.tableData.length / this.pageSize
                    );
                }
            } else if (event === 'edit') {
                this.tableData.map(item => {
                    delete item.editRow;
                });
                this.$set(this.tableData[index], 'editRow', true);
                this.dataInit();
            }
        }
    }
};
</script>

<style lang="less">
.dialogTable {
    .dialogTablePagination {
        padding-top: 20px;
        position: absolute;
        .table-pagination{
            float: right;
            padding: 0;
            .btn-prev, .btn-next, .el-pager li {
                background-color: #ffffff !important;
                border: 1px solid #cccccc;
                border-radius: 4px !important;
                padding:0;
                min-width: 30px;
                margin-right:4px;
            }
            .el-pager li.active + li {
                border-left: 1px solid #cccccc;
            }
            .el-pager li:not(.disabled).active{
                background-color: #00BCBF !important;
                border: 1px solid #00BCBF;
                color:#ffffff;
            }
        }
    }
    .showMustFill {
        .el-input__inner {
            border: 1px solid #f00;
        }
    }
    .el-table .cell {
        padding-left: 8px;
        padding-right: 8px;
    }
}
</style>